<div class="sidebar-wrapper">
  <div>
    <img src="assets/img/vx-management-logo.png" class="domain-logo-img" />
  </div>
  <ul class="nav responsive-nav">
    <ng-container *ngFor="let menuItem of menuItems">
      <li routerLinkActive="active">
        <a
          [routerLink]="menuItem.path"
          [class.sidebar-feature-link]="menuItem.beta"
        >
          <i class="{{ menuItem.icon }}"></i>
          <div
            *ngIf="menuItem.beta; else defaultMenuLabel"
            class="sidebar-feature-copy"
          >
            <div class="sidebar-feature-title-row">
              <span class="sidebar-feature-title">{{ menuItem.title }}</span>
              <span class="sidebar-beta-badge">Beta</span>
            </div>
            <span class="sidebar-feature-subtitle">{{
              menuItem.subtitle
            }}</span>
          </div>
          <ng-template #defaultMenuLabel>
            <p class="sidebar-menu-labels">{{ menuItem.title }}</p>
          </ng-template>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
